export default {
  namespaced: true,
  state: () => {
    return {
      given: {
        functional: true,
        performance: false,
        marketing: false,
      },
    }
  },
  mutations: {
    setConsents(state, consents) {

      Object.keys(consents).forEach((key) => {
        if (typeof state.given[key] === 'undefined') {
          throw new Error(`Unknown consent type: ${key}`)
        }
      })

      state.given = {
        ...state.given,
        ...consents,
      }
    },
    setAll(state, value) {
      const newState = { ...state.given }
      for (const key in newState) {
        newState[key] = value
      }
      state.given = newState
    },
  },
}
